import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SeoHead } from 'modules/seo';
import { useWorkorderDocuments, WorkorderType } from 'modules/entities/modules/workorder-documents';

import { DocumentInfo } from '../DocumentInfo';

import { NotfallplanSearchPanel } from './SearchPanel/SearchPanel';
import { ActionPanel } from './ActionPanel';
import { NotfallplanTable } from './Table';
import { useRouteMatch } from 'react-router-dom';

export const NotfallplanTab = () => {
    const intl = useIntl();
    const { loading, documents, defaultSearch } = useWorkorderDocuments(WorkorderType.NP);
    const match = useRouteMatch('/elevators/:id');

    return (
        <>
            <SeoHead title={intl.formatMessage({ id: 'documents.notfallplan.title' })} />
            <DocumentInfo>
                <FormattedMessage id="documents.notfallplan.info" />
            </DocumentInfo>
            <NotfallplanSearchPanel defaultValue={defaultSearch} isElevatorDetail={match?.isExact} />
            <ActionPanel documents={documents} />
            <NotfallplanTable loading={loading} documents={documents} isElevatorDetail={match?.isExact} />
        </>
    );
}; 